import { render } from "./project-dashboard.vue?vue&type=template&id=122633b5&scoped=true"
import script from "./project-dashboard.vue?vue&type=script&lang=js"
export * from "./project-dashboard.vue?vue&type=script&lang=js"

import "./project-dashboard.vue?vue&type=style&index=0&id=122633b5&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-122633b5"]])

export default __exports__